import styled from 'styled-components';
import { borderRadius, colorUsage, getSpacing, gradientText, lineHeight, typography } from 'stylesheet';
import { Close } from 'theme/icons';
var Title = styled.h1.withConfig({
  displayName: "AffiliationLinkDialogstyle__Title",
  componentId: "sc-b5os4n-0"
})(["", " ", ""], typography.h1, gradientText);
var CloseButton = styled(Close).withConfig({
  displayName: "AffiliationLinkDialogstyle__CloseButton",
  componentId: "sc-b5os4n-1"
})(["position:absolute;right:", ";cursor:pointer;& path{fill:", ";}"], getSpacing(3), colorUsage.textColor);
var LoaderContainer = styled.div.withConfig({
  displayName: "AffiliationLinkDialogstyle__LoaderContainer",
  componentId: "sc-b5os4n-2"
})(["display:flex;justify-content:center;width:500px;height:140px;margin:", ";"], getSpacing(1));
var Description = styled.p.withConfig({
  displayName: "AffiliationLinkDialogstyle__Description",
  componentId: "sc-b5os4n-3"
})(["margin-top:", ";text-align:center;"], getSpacing(1));
var SelectedItemContainer = styled.div.withConfig({
  displayName: "AffiliationLinkDialogstyle__SelectedItemContainer",
  componentId: "sc-b5os4n-4"
})(["position:relative;width:500px;margin-top:", ";padding:", ";border:1px solid ", ";border-radius:", ";"], getSpacing(1), getSpacing(1), colorUsage.searchItemList.borderColor, borderRadius.medium);
var ItemTitle = styled.div.withConfig({
  displayName: "AffiliationLinkDialogstyle__ItemTitle",
  componentId: "sc-b5os4n-5"
})(["font-weight:bold;"]);
var ItemSubTitle = styled.div.withConfig({
  displayName: "AffiliationLinkDialogstyle__ItemSubTitle",
  componentId: "sc-b5os4n-6"
})(["height:", ";overflow:hidden;color:", ";"], lineHeight.normal, colorUsage.searchItemList.subTitleColor);
var ItemInvalid = styled(ItemSubTitle).withConfig({
  displayName: "AffiliationLinkDialogstyle__ItemInvalid",
  componentId: "sc-b5os4n-7"
})(["color:", ";"], colorUsage.message.error);
var ButtonContainer = styled.div.withConfig({
  displayName: "AffiliationLinkDialogstyle__ButtonContainer",
  componentId: "sc-b5os4n-8"
})(["display:flex;margin-top:", ";column-gap:10px;"], getSpacing(2));
export { ButtonContainer, CloseButton, LoaderContainer, Description, ItemInvalid, ItemSubTitle, ItemTitle, SelectedItemContainer, Title };